// extracted by mini-css-extract-plugin
module.exports = {"articleWrapper":"artykul-module--articleWrapper--2lfYv","mainImgWrapper":"artykul-module--mainImgWrapper--899am"};